import type { CardGallery } from "~/core";

export const isCardGallery = (item: unknown): item is CardGallery => {
  return (
    typeof item === "object" &&
    item !== null &&
    "__typename" in item &&
    item.__typename === "card_gallery" &&
    "cards" in item &&
    item.cards !== null
  );
};
